export default __webpack_public_path__ + "static/media/new-truck.2a342f86.svg";